import { createWebHistory, createRouter } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import TierView from '../views/TierView.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomeView,
    },
    {
        path: '/tier/:slug',
        name: 'Tier',
        component: TierView,
        props: true,
        meta: {
            title: 'Tiers | EDH and Other Bullshit',
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((toRoute, fromRoute, next) => {
    window.document.title = toRoute.meta && toRoute.meta.title ? toRoute.meta.title : 'EDH and Other Bullshit';

    next();
});

export default router;
